import { LoadingOutlined, ReloadOutlined } from '@ant-design/icons';
import { DetailsContainer } from 'Components/shared/details-container'
import { toaster } from 'Helpers/index';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { authResendVerifyEmail } from 'Services/index';
import { DataListType } from 'Types/common.types'
import { FetchedUserData } from 'Types/user.types';
import "./user-details.scss";
interface UserDetailsProps {
  userDetails:FetchedUserData;
}

const UserDetails:React.FC<UserDetailsProps> = ({
  userDetails,
}) => {

  const { t } = useTranslation();
  const [isResendEmailLoading, setIsResendEmailLoading] =
    useState<boolean>(false);

  const resendVerifyEmail = async () => {
    setIsResendEmailLoading(true);
    const email = userDetails?.profile?.email!;
    const pendingEmail = userDetails.profile?.pendingEmail;
    const responseData = await authResendVerifyEmail({ email, pendingEmail });

    const showSuccessToast = () => {
      toaster("success", t("toaster.checkEmail"));
    };

    const showErrorToast = (errorMessage: any) => {
      toaster(
        "error",
        typeof errorMessage === "string"
          ? errorMessage
          : errorMessage?.message?.replace('"', "") ?? "An error occurred",
      );
    };

    setTimeout(() => {
      responseData && !responseData.error
        ? showSuccessToast()
        : showErrorToast(responseData?.error?.message);
      setIsResendEmailLoading(false);
    }, 3000);
  };

  const userInfo: DataListType[] = [
    {
      label: t("label.fullName"),
      value: userDetails?.profile?.fullName ?? '-',
    },
    {
      label: t("label.passportID"),
      value: userDetails?.profile?.idPassportNo ?? "-",
    },
    {
      label: t("label.email"),
      value: (
        <div className="user-details">
          {userDetails.profile?.email}
          {!userDetails.profile?.pendingEmail && (
            isResendEmailLoading ? (
              <LoadingOutlined className="resend-email-icon" />
            ) : (
              <ReloadOutlined
                className="resend-email-icon"
                onClick={resendVerifyEmail}
              />
            )
          )}
        </div>
      ),
    },
    {
      label: t("label.mobileNo"),
      value: userDetails?.profile?.mobileNo?.fullNumber ?? "-",
    },
    {
      label: t("label.gender"),
      value: userDetails.profile?.gender ?? "-",
    },
    {
      label: t("label.homeAddress"),
      value: userDetails.profile?.fullAddress ?? "-",
    },
  ]

  if (userDetails.profile?.pendingEmail) {
    userInfo.splice(3, 0, {
      label: t("label.pendingEmailAddress"),
      value: (
        <div className="user-details">
          {userDetails.profile?.pendingEmail}
           {isResendEmailLoading ? (
            <LoadingOutlined className="resend-email-icon" />
          ) : (
            <ReloadOutlined
              className="resend-email-icon"
              onClick={resendVerifyEmail}
            />
          )} 
        </div>
      ),
    });
  }

  return <DetailsContainer listOfData={userInfo} />;
}

export default UserDetails